import { combineReducers } from 'redux';
import commonReducers from './reducers';
import commissionsSummaryReducers from './../commissions/summary/reducers.js';
import commissionsDetailsReducers from './../commissions/details/reducers.js';

import bObSummaryReducers from './../clients/reducers.js';
import quoteReducers from '../containers/Quotes/reducers.js';

import messagingReducers from './../messaging/reducers.js';
import headerReducers from './../header/reducers.js';
import homeReducers from './../home/reducers';
import modalDialogReducers from './../modalDialog/reducers.js';
import renewalsSummaryReducers from './../renewals/reducers.js';
import quotesSummaryReducers from './../containers/QuotesSummary/reducers.js';
import bobClientDetailsReducers from './../containers/ClientDetails/reducers.js';
import renewalsDetailsReducers from './../containers/RenewalDetails/reducers.js';
import messagesReducer from './../containers/MessageCenter/reducers.js';
import adminToolReducers from './../containers/AdminPage/reducers.js';
import employeeReducer from './../containers/EmployeeDetails/reducers.js';
import accountDetailsReducer from './../containers/AccountDetails/reducers.js';
import incomingBusinessSummaryReducer from './../incomingBusiness/summary/reducers.js';
import agenctConnectReducers from './../containers/AgentConnect/reducers.js';
import allResourcesAndFormsReducers from '../containers/AllResourcesAndForms/reducers';
import promotionalProductReducers from './../promotionalProduct/reducers.js';
import attestationOwcsMessagesReducers from './../components/AttestationForm/reducers';
import reportsReducers from './../containers/Reports/reducers';
import hippaAttestationReducer from './../hippaAttestation/reducers.js';
import appSidebarReducer from './../appSidebar/reducers';
import dashboardReducers from './../dashboard/reducers';
import sgqReducers from './../containers/SGQContainer/reducers.js';
import techAuthReducers from './../containers/Authorization/reducers';
import s2sReducers from '../s2sMigration/reducers';
import detailsContainerReducer from '../containers/DetailsContainer/reducers.js';
import dashboardReducer from '../DashboardV2/redux/reducers'

const combinedReducer = combineReducers({
  commonReducers,
  commissionsSummaryReducers,
  commissionsDetailsReducers,
  renewalsDetailsReducers,
  bObSummaryReducers,
  quoteReducers,
  messagingReducers,
  headerReducers,
  homeReducers,
  modalDialogReducers,
  renewalsSummaryReducers,
  bobClientDetailsReducers,
  incomingBusinessSummaryReducer,
  quotesSummaryReducers,
  messagesReducer,
  agenctConnectReducers,
  adminToolReducers,
  employeeReducer,
  accountDetailsReducer,
  allResourcesAndFormsReducers,
  promotionalProductReducers,
  attestationOwcsMessagesReducers,
  reportsReducers,
  hippaAttestationReducer,
  appSidebarReducer,
  dashboardReducers,
  sgqReducers,
  techAuthReducers,
  s2sReducers,
  detailsContainerReducer,
  dashboardReducer
});

export default combinedReducer;
